/**
 * Created by Zac on 22/05/2016.
 */
import Debug from 'debug';
 import {hidePopovers} from './lobuilder.jquery.js'
const debug = Debug('gh:lobuilder:hotspots');

 $(function () {
  var pastHotSpotsString = Cookies.get('pastHotSpots');
  if (pastHotSpotsString) {
    var pastHotSpotsString = pastHotSpotsString.split(',');
    // see if the has been active in the post
    $(pastHotSpotsString).each(function (pIndex, past) {
      // loop over the hospots

      let pastHotspot = $(`.hotspot a[data-target="#${past}"]`);
      pastHotspot.removeClass('HotspotRailroad');

      if(pastHotspot.length==0){
          pastHotspot = $(`.hotspot a[data-targetpage="${past}"]`);
      }

      if(pastHotspot.length==0){
        pastHotspot = $(`.hotspot a[href="${past}"]`);
      }

      const active = pastHotspot.attr('data-active');
      if (active && active.length >= 0) { // switch the hotspot if active image exists.
        pastHotspot.find('img').attr('src', active); // update the image
      }
      // make the next one active
      const nextHotspot = $(`#${pastHotspot.attr('data-next')}`);
      nextHotspot.removeClass('HotspotRailroad');
    });
  }

  function getHotspotTarget(eTarget){
    let type, theLink, parts, target;
    if ($(eTarget).data('target') && $(eTarget).data('target') != '#') {
       type = 'scene';
       theLink = $(eTarget).data('target');
       parts = theLink.split('#');
       target = parts[1];
    } else if ($(eTarget).data('targetpage')) {
       type = 'page';
       target = $(eTarget).data('targetpage');
       const getExtension = $(eTarget).attr('href').match(/\.[0-9a-z]+$/i);
       const isHTML = getExtension && Array.isArray(getExtension) && getExtension[0].indexOf('html') > -1;
       if(window.SCORMAPI || isHTML){
         target = $(eTarget).attr('href');
       }

    } else if ($(eTarget).data('trigger')) {
       type = 'trigger';
       target = $(eTarget).data('trigger');
    }
    return {type, theLink, parts, target};
  }
  function hotspotClickEvent(event) { // when we get a click
    // a horrible cludge to force slides to the full width of the slideshow panel
    $('.sp-slide').css('width', '100%');
    $('.sp-mask').css('width', '100%');
    // if we're running our hotspots one at a time
    // then scenes the user can't visit yet will have the HotspotRailroad class on them
    // if ($(this).hasClass('visible-xs')){
    //     var otherHotSpot = $(this).closest('.HotSpotImage').parent().children('.HotSpotImage.hidden-xs');
    //     otherHotSpot.remove();
    //
    // } else {
    //     var otherHotSpot = $(this).closest('.HotSpotImage').parent().children('.HotSpotImage');
    //     otherHotSpot.remove();
    // // }
    // $(this).closest('.HotSpotImage').removeClass('visible-xs hidden-xs visible-md hidden-md visible-lg  hidden-lg');
    if ($(this).closest('.HotSpotImage').hasClass('HotSpotDefault')) {
      event.stopImmediatePropagation();
    }

    if ($(this).hasClass('HotspotRailroad')) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    } else { // set up the next hotspot to allow clicking etc (if needed) and reveal the linked scene
      const next = $(this).data('next');
      $(`#${next}`).removeClass('HotspotRailroad'); // /TODO Remove the id
      // $('#xs-' + next).removeClass('HotspotRailroad');

      if (event) {
        event.returnValue = false;
      }
      event.preventDefault ? event.preventDefault() : event.returnValue = false;

      const {type, theLink, parts, target} = getHotspotTarget(event.currentTarget);

      const active = $(this).attr('data-active');
      // alert($(this).find("img").attr('src'));
      // alert(active);
      if (active.trim() != '') { // switch the hotspot if active image exists.
        $(this).find('img').attr('src', active); // update the image
      }

      // add this to list of past hotspots - these are store in a string that is formated like so  "somewhere","linktothemoon","earth"
      let pastHotSpotsString = Cookies.get('pastHotSpots');
        if(window.SCORMAPI){
            var checkHtml = target.split('.html')[0]
            pastHotSpotsString = pastHotSpotsString + ',' +checkHtml;
        }else {
            pastHotSpotsString = `${pastHotSpotsString},${target}`;
        }

      Cookies.set('pastHotSpots', pastHotSpotsString, {
        expires: 30,
      });

      // this what happens for screens
      if (type == 'scene') {
        // alert('wow its a scene');
        event.stopImmediatePropagation();
        event.preventDefault();

        // var hotspotImageDivs = $(event.target).closest(".HotSpotImage").parent().children('.HotSpotImage');
        // var activityContentDivs = $(event.target).closest(".HotSpotImage").parent().children('.activityContent');

        // hotspotImageDivs.hide();
        // activityContentDivs.hide();

        store.dispatch(actions.setSceneByName(target));
        // $(".scene." + target).show(); // toggle the next one

        // console.log($(event.target).closest(".HotSpotImage").prev().prev());
        // $(event.target).closest(".HotSpotImage").prev().prev().hide(); //removes the activity content before the hotsot.
        // $(event.target).closest(".HotSpotImage").hide(); //turn off the hotspots that are near by
        // //$(event.target).closest(".HotSpotImage").css("cssText", "border: none !important;");
        // $(event.target).closest(".HotSpotImage").next(".activityContent").hide(); // remove the actvity content afterwards.
        // alert(".scenes ." + target);


        $.event.trigger({
          type: 'changeScene',
          message: target,
          time: new Date(),
        });
      } else if (type == 'page') {
        // alert('wow its a page');

        const theurl = `/${target}`;
        const getExtension  = target.match(/\.[0-9a-z]+$/i);
        const isHTML = getExtension && Array.isArray(getExtension) && getExtension[0].indexOf('html')>-1;
        if(window.SCORMAPI || isHTML){
            window.location.replace(target);
        }else {
            window.location.href = theurl; // This might not work on live server
        }

      } else {
        openModal(target, {context: this});
      }

      Cookies.set(currentCookie, target, {
        expires: 30,
      });
    }
  }

  $.each($('.hotspot a, .xs-hotspot a, .HotSpotDefault'), function (index, element) {
    const modElement = $(element).data('trigger');
    if (modElement == null) {
      return true;
    }
    const shouldWeHover = $(`#${modElement}_modal`).data('hover');
    if (shouldWeHover == 1) {
      $(element).on('mouseenter', hotspotClickEvent);
      $(element).on('mouseleave', function () {
        debug('Mouse left the hotspot trigger');

        if ($(`.popover:hover`).length == 0){
          debug('Mouse left the hotspot trigger and not on the popover')
          hidePopovers();
        } else {
          $('.popover').on('mouseleave', function () {
            debug('Now closing the popover');
            hidePopovers();
          });
        }

        // $(this).popover('hide');

        // if (!$('.popover:hover').length) {
        //   console.log($(this).filter(':hover'));
        //   if ($(this).filter(':hover').length == 0) {
        //     $(this).popover('hide');
        //   }
        // } else {
        //   $('.popover').on('mouseleave', function () {
        //     // console.log($(this).siblings().first().is(':hover'));
        //     console.log($(this).siblings().first().filter(':hover'));
        //     if ($(this).siblings().first().filter(':hover').length == 0) {
        //       // console.log($(this).siblings().first().is(':hover'));
        //       hidePopovers();
        //     }
        //   });
        // }
      });
    } else {
      $(element).on('click', hotspotClickEvent); // end of onclick event
    }
  });

  $('.js__hotspot__link').each(function () {

      if($(this).hasClass('HotspotRailroad')){
          $(this).attr('tabindex',-1)
      }
  })

     $('.aria-hidden').each(function () {

        $(this).attr('aria-hidden',true)
     })
  // the the event the handles the click
})
;



// WEBPACK FOOTER //
// Glasshouse/Core/js/hotspots.js